import React from 'react'
import { Popover } from '@headlessui/react'
import DropDownList from '@/components/SpeakerFilter/DropDownList'
import SpeakerType from '@/components/SpeakerFilter/SpeakerType'
import Category from '@/components/SpeakerFilter/Category'

const SpeakerFilterContainer = ({
  categories = [],
  selectedCategories,
  selectedCategoriesNames,
  handleCategoryChange,
  speakerTypes = [],
  selectedSpeakerTypes,
  selectedSpeakerTypeNames,
  handleSpeakerTypeChange,
  sortOrder,
  handleSortSpeakers,
  onParentCategoryClick,
  sortTypes,
  handleFilterSpeakers,
}) => (
  <div className="relative hidden gap-4 mt-4 md:grid md:grid-cols-3">
    <DropDownList title={'Categories & Topics'}>
      <Popover.Panel className="absolute left-0 right-0 z-50 px-4 border bg-black border-custom-gray-80 bg-opacity-95 -mt-[1px]">
        {({ close }) => (
          <Category
            categories={categories}
            selectedCategoriesNames={selectedCategoriesNames}
            selectedCategories={selectedCategories}
            selectedSpeakerTypes={selectedSpeakerTypes}
            selectedSpeakerTypeNames={selectedSpeakerTypeNames}
            handleCategoryChange={handleCategoryChange}
            handleFilterSpeakers={() => {
              handleFilterSpeakers('Categories')
              close()
            }}
            onParentCategoryClick={onParentCategoryClick}
          />
        )}
      </Popover.Panel>
    </DropDownList>
    <div className="z-10 grid w-full h-0 grid-cols-2 col-span-2 gap-4">
      <DropDownList title={'Speaker Types'}>
        <Popover.Panel className="absolute left-0 right-0 z-50 px-4 pt-8 border bg-black border-custom-gray-80 bg-opacity-95 top-submenu">
          {({ close }) => (
            <SpeakerType
              speakerTypes={speakerTypes}
              selectedCategoriesNames={selectedCategoriesNames}
              selectedCategories={selectedCategories}
              selectedSpeakerTypes={selectedSpeakerTypes}
              selectedSpeakerTypeNames={selectedSpeakerTypeNames}
              handleSpeakerTypeChange={handleSpeakerTypeChange}
              handleFilterSpeakers={() => {
                handleFilterSpeakers('Speaker Type')
                close()
              }}
            />
          )}
        </Popover.Panel>
      </DropDownList>

      <div>
        <DropDownList title={sortOrder?.label}>
          <Popover.Panel className="bg-black relative bottom-5 z-[999] px-5 pb-3 border border-custom-gray-80 border-t-0 bg-opacity-95">
            {({ close }) =>
              sortTypes?.map((sort, index, arr) => (
                <>
                  <span
                    role="button"
                    key={`sort ${sort?.label}`}
                    aria-label={`sort ${sort?.label}`}
                    className="leading-[2rem] text-xs cursor-pointer tagline-font"
                    onClick={() => {
                      handleSortSpeakers(sort)
                      close()
                    }}
                    name={sort?.label}
                  >
                    {sort?.label}
                  </span>
                  {arr.length > index && <br />}
                </>
              ))
            }
          </Popover.Panel>
        </DropDownList>
      </div>
    </div>
  </div>
)

export default React.memo(SpeakerFilterContainer)
